import {
  CompanyActivity,
  DocumentType,
  EmploymentStatus,
  Gender,
  MaritalRegime,
  MaritalStatus,
  NetIncomeType,
  OnboardingDetailsRole,
  ProfessionalPosition,
  Relation,
  ResidenceOwnership,
  ResidenceProperty,
} from '@nemuru-eng/js-api-client';

import { NIE_DATA_FORM_BLANK_VALUES } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/constants/nieDataFormBlankValues';
import { BorrowerOnboardingDetailsFormType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/schemas/borrowerOnboardingDetailsForm.schema';
import { ADDRESS_DEFAULT_VALUES } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/constants/AddressDefaultValues';
import { DefaultDialCodeOption } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/constants/DefaultDialCodeOption';

export const MERCHANT_POS_DEFAULT_VALUES: Record<OnboardingDetailsRole, BorrowerOnboardingDetailsFormType> = {
  [OnboardingDetailsRole.BORROWER]: {
    email: 'ramon.borras@nemuru.com',
    dialCode: DefaultDialCodeOption,
    phoneNumber: '687090145',
    firstName: 'Ramon',
    lastName: 'Borras Pinilla',
    documentType: DocumentType.NIF,
    gender: Gender.F,
    nationality: 'ESP',
    documentExpeditor: 'ESP',
    expiration: new Date('2030-12-17'),
    birthDate: new Date('1996-03-19'),
    birthPlace: 'Barcelona',
    documentNumber: '51876167N',
    documentAddress: ADDRESS_DEFAULT_VALUES,
    mainResidenceAddress: ADDRESS_DEFAULT_VALUES,
    ownershipType: ResidenceOwnership.OWNERSHIP,
    homeExpenses: '476',
    entranceDate: new Date('2018-09'),
    propertyType: ResidenceProperty.PUBLIC_DEED,
    mortgage: 'true',
    maritalStatus: MaritalStatus.MARRIED,
    childSupportNumber: 2,
    maritalRegime: MaritalRegime.MATRIMONIAL_ASSETS,
    employmentStatus: EmploymentStatus.INDEFINITE_EMPLOYED,
    professionalPosition: ProfessionalPosition.VETERINARY,
    companyName: 'Hospital Veterinari Montjuïc',
    companyCity: 'Barcelona',
    companyActivity: CompanyActivity.VETERINARY_MEDICINE,
    corporateIdNumber: 'R4183448B',
    seniority: new Date('2020-12-01'),
    numberOfYearlyPayments: 14,
    monthlyNetIncome: '2800',
    netIncomeType: NetIncomeType.SALARY,
    bankAccountNumber: 'ES1001285437932557986126',
    ...NIE_DATA_FORM_BLANK_VALUES,
  },
  [OnboardingDetailsRole.CO_BORROWER]: {
    relation: Relation.SPOUSE,
    email: 'julia.borras@nemuru.com',
    dialCode: DefaultDialCodeOption,
    phoneNumber: '687090145',
    firstName: 'Julia',
    lastName: 'Borras Pinilla',
    documentType: DocumentType.NIF,
    gender: Gender.M,
    nationality: 'ESP',
    documentExpeditor: 'ESP',
    expiration: new Date('2030-12-17'),
    birthDate: new Date('1977-02-02'),
    birthPlace: 'Barcelona',
    documentNumber: '21671588E',
    documentAddress: ADDRESS_DEFAULT_VALUES,
    mainResidenceAddress: ADDRESS_DEFAULT_VALUES,
    ownershipType: ResidenceOwnership.OWNERSHIP,
    homeExpenses: '80',
    entranceDate: new Date('1992-09-17'),
    propertyType: ResidenceProperty.PUBLIC_DEED,
    mortgage: 'false',
    maritalStatus: MaritalStatus.MARRIED,
    childSupportNumber: 2,
    maritalRegime: MaritalRegime.MATRIMONIAL_ASSETS,
    employmentStatus: EmploymentStatus.RETIRED,
    numberOfYearlyPayments: 14,
    monthlyNetIncome: '2300',
    netIncomeType: NetIncomeType.SALARY,
    bankAccountNumber: '',
    ...NIE_DATA_FORM_BLANK_VALUES,
  },
  [OnboardingDetailsRole.GUARANTOR]: {
    relation: Relation.SIBLING,
    email: 'german.pinill@nemuru.com',
    dialCode: DefaultDialCodeOption,
    phoneNumber: '687090145',
    firstName: 'Josep',
    lastName: 'Pinilla Martin',
    documentType: DocumentType.NIF,
    gender: Gender.M,
    nationality: 'ESP',
    documentExpeditor: 'ESP',
    expiration: new Date('2030-12-17'),
    birthDate: new Date('1999-09-19'),
    birthPlace: 'Barcelona',
    documentNumber: '19557111G',
    documentAddress: ADDRESS_DEFAULT_VALUES,
    mainResidenceAddress: ADDRESS_DEFAULT_VALUES,
    ownershipType: ResidenceOwnership.OWNERSHIP,
    homeExpenses: '876',
    entranceDate: new Date('2018-09-17'),
    propertyType: ResidenceProperty.PUBLIC_DEED,
    mortgage: 'true',
    maritalStatus: MaritalStatus.MARRIED,
    childSupportNumber: 2,
    maritalRegime: MaritalRegime.MATRIMONIAL_ASSETS,
    employmentStatus: EmploymentStatus.INDEFINITE_EMPLOYED,
    professionalPosition: ProfessionalPosition.VETERINARY,
    companyName: 'Hospital Veterinari Montjuïc',
    companyCity: 'Barcelona',
    companyActivity: CompanyActivity.VETERINARY_MEDICINE,
    seniority: new Date('2020-12-01'),
    numberOfYearlyPayments: 14,
    monthlyNetIncome: '2300',
    netIncomeType: NetIncomeType.SALARY,
    bankAccountNumber: '',
    ...NIE_DATA_FORM_BLANK_VALUES,
  },
};
